import ReactPixel from 'react-facebook-pixel';

// Función centralizada para saber si estamos en pruebas o desarrollo
const isTestEnvironment = () => {
  const hostname = window.location.hostname;
  // Bloquea el envío si estás en localhost o en el subdominio de pruebas
  return hostname === "localhost" || hostname.includes("pruebas.dissempacademy.com");
};

// Inicializar el Pixel de Meta solo en producción
export const initMetaPixel = () => {
  if (isTestEnvironment()) {
    console.log(`🛑 [MODO PRUEBA] Pixel de Meta DESACTIVADO en: ${window.location.hostname}`);
    return;
  }

  const pixelId = '3548485838787487';
  ReactPixel.init(pixelId);
  ReactPixel.pageView();
  console.log("✅ Pixel de Meta ACTIVADO");
};

// Función para rastrear eventos personalizados
export const trackMetaEvent = (eventName, data = {}) => {
  if (isTestEnvironment()) {
    console.log(`🛑 [MODO PRUEBA] Evento Meta '${eventName}' NO enviado. Datos simulados:`, data);
    return;
  }

  ReactPixel.track(eventName, data);
  console.log(`✅ Evento Meta '${eventName}' enviado exitosamente con datos:`, data);
};